/* CC Mega Menu — campaigns 21128974 + 95109856 */
(function () {

  function ccScrollDetect() {
    var st = document.documentElement.scrollTop || document.body.scrollTop;
    document.body.classList.toggle('cc-sticky-active', st > 50);
    document.body.classList.toggle('cc-act', st > 100);
  }

  function closeAllProductPanels() {
    document.querySelectorAll('.cc-bestseller-dropdown').forEach(function (p) { p.style.display = 'none'; });
    document.querySelectorAll('.cc-has-product-panel.cc-panel-open').forEach(function (t) { t.classList.remove('cc-panel-open'); });
  }

  function getHeaderBottom() {
    // Measure the full sticky stack (free-shipping-bar + header, including the
    // logo row) — not #SiteNav, which is just the nav-links row and sits
    // vertically centered inside the taller header, so its own bottom edge
    // lands above the header's true bottom and cuts off the logo.
    var stack = document.querySelector('.cc-top-sticky');
    if (stack) return Math.round(stack.getBoundingClientRect().bottom);
    var header = document.querySelector('.site-header');
    if (header) return Math.round(header.getBoundingClientRect().bottom);
    var nav = document.getElementById('SiteNav');
    return nav ? Math.round(nav.getBoundingClientRect().bottom) : 0;
  }

  function updateFixedPositions() {
    // Runs on every scroll event, so two things matter: (1) skip the forced layout
    // read entirely when no dropdown is open — true for nearly all scroll time —
    // and (2) when one IS open, avoid reading getBoundingClientRect() right after
    // writing bar.style.top. That write invalidates layout, so the read that used
    // to follow it forced a synchronous reflow on every scroll tick (measured at
    // 65ms of forced-reflow time). bar's height doesn't change from moving it, so
    // its new bottom can be computed arithmetically instead of re-measured.
    var openBars = document.querySelectorAll('.cc-sub-category-shown.cc-category-shown');
    if (!openBars.length) return;

    var headerBottom = getHeaderBottom();
    openBars.forEach(function (bar) {
      var barHeight = bar.getBoundingClientRect().height;
      bar.style.top = headerBottom + 'px';
      var barBottom = headerBottom + barHeight;
      var openGlock = bar.querySelector('.cc-childcat-shown');
      if (openGlock) openGlock.style.top = barBottom + 'px';
      var openPanel = bar.querySelector('.cc-bestseller-dropdown');
      if (openPanel && openPanel.style.display === 'block') openPanel.style.top = barBottom + 'px';
    });
  }

  function loadSiema(cb) {
    if (typeof Siema !== 'undefined') { cb(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/siema@1.5.1/dist/siema.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }

  function getPerPage() {
    var w = window.innerWidth;
    if (w >= 1024) return 4;
    if (w >= 768)  return 3;
    if (w >= 480)  return 2;
    return 1;
  }

  function initProductSlider(panel) {
    if (panel.getAttribute('data-slider-init') === '1') return;
    var track = panel.querySelector('.cc-pick-list');
    if (!track || !track.children.length) return;
    loadSiema(function () {
      var slider = new Siema({ selector: track, perPage: getPerPage(), loop: false, duration: 300, easing: 'ease-out' });
      panel.setAttribute('data-slider-init', '1');
      var container = panel.querySelector('.cc-container');
      if (container) {
        var prev = container.querySelector('.cc-prod-prev');
        var next = container.querySelector('.cc-prod-next');
        if (prev) prev.onclick = function (e) { e.stopPropagation(); slider.prev(); };
        if (next) next.onclick = function (e) { e.stopPropagation(); slider.next(); };
      }
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (panel.style.display !== 'none') {
            slider.destroy(true);
            panel.removeAttribute('data-slider-init');
            initProductSlider(panel);
          }
        }, 250);
      });
    });
  }

  function initMegaMenu() {
    var dataEl = document.getElementById('cc-mega-data');
    if (!dataEl) return;

    dataEl.querySelectorAll('[data-cc-nav]').forEach(function (navData) {
      var title = navData.getAttribute('data-cc-nav');
      document.querySelectorAll('#SiteNav .site-nav__link--button').forEach(function (btn) {
        var label = btn.querySelector('.site-nav__label');
        if (!label || label.textContent.trim() !== title) return;
        var dropdown = document.getElementById(btn.getAttribute('aria-controls'));
        if (!dropdown) return;
        dropdown.classList.add('cc-sub-category-shown');
        dropdown.innerHTML = navData.innerHTML;
      });
    });

    var siteNav = document.getElementById('SiteNav');
    if (siteNav) {
      siteNav.addEventListener('click', function (e) {

        var catLink = e.target.closest('.cc-sub-category-shown .cc-category-link');
        if (catLink && catLink.getAttribute('href') === '#') { e.preventDefault(); return; }

        var btn = e.target.closest('.site-nav__link--button');
        if (btn) {
          var id = btn.getAttribute('aria-controls');
          document.querySelectorAll('.cc-sub-category-shown.cc-category-shown').forEach(function (el) {
            if (el.id !== id) { el.classList.remove('cc-category-shown'); closeAllProductPanels(); }
          });
          var target = document.getElementById(id);
          if (target) {
            var wasOpen = target.classList.contains('cc-category-shown');
            if (!wasOpen) target.style.top = getHeaderBottom() + 'px';
            target.classList.toggle('cc-category-shown');
            if (wasOpen) closeAllProductPanels();
          }
          return;
        }

        var productTrigger = e.target.closest('.cc-has-product-panel');
        if (productTrigger) {
          if (e.target.closest('.cc-pc-atc-btn') ||
              e.target.closest('.cc-qty-btn') ||
              e.target.closest('.cc-qty-input') ||
              e.target.closest('.cc-prod-arrow') ||
              e.target.closest('.cc-bestseller-dropdown a[href]')) return;
          var panel = productTrigger.querySelector('.cc-bestseller-dropdown');
          if (panel) {
            var isOpen = panel.style.display === 'block';
            closeAllProductPanels();
            document.querySelectorAll('.cc-childcat-shown').forEach(function (el) { el.classList.remove('cc-childcat-shown'); });
            if (!isOpen) {
              var activeDropdown = productTrigger.closest('.cc-sub-category-shown');
              if (activeDropdown) panel.style.top = activeDropdown.getBoundingClientRect().bottom + 'px';
              panel.style.display = 'block';
              productTrigger.classList.add('cc-panel-open');
              initProductSlider(panel);
            }
          }
          return;
        }

        var hvract = e.target.closest('.cc-hvract');
        if (hvract && !hvract.classList.contains('cc-has-product-panel')) {
          closeAllProductPanels();
          var glock = hvract.querySelector('.cc-sbm-glock');
          if (glock) {
            var bar = hvract.closest('.cc-sub-category-shown');
            if (bar && !glock.classList.contains('cc-childcat-shown')) glock.style.top = bar.getBoundingClientRect().bottom + 'px';
            glock.classList.toggle('cc-childcat-shown');
          }
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('#SiteNav') && !e.target.closest('.cc-bestseller-dropdown') && !e.target.closest('.cc-sbm-glock')) {
        document.querySelectorAll('.cc-category-shown').forEach(function (el) { el.classList.remove('cc-category-shown'); });
        document.querySelectorAll('.cc-childcat-shown').forEach(function (el) { el.classList.remove('cc-childcat-shown'); });
        closeAllProductPanels();
      }
    });

    ccScrollDetect();
    window.addEventListener('scroll', function () {
      ccScrollDetect();
      updateFixedPositions();
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cc-pc-atc-btn');
      if (!btn) return;
      e.stopImmediatePropagation();
      e.stopPropagation();
      var vid = parseInt(btn.getAttribute('data-vid'));
      var card = btn.closest('.cc-newpds');
      var qty = card ? (parseInt((card.querySelector('.cc-qty-input') || {}).value) || 1) : 1;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: qty })
      }).then(function (res) {
        if (!res.ok) throw new Error();
        btn.textContent = 'Added!';
        setTimeout(function () { window.location.href = '/cart'; }, 500);
      }).catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 2000);
      });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cc-qty-btn');
      if (!btn) return;
      e.stopPropagation();
      var input = btn.closest('.cc-quantity-section') && btn.closest('.cc-quantity-section').querySelector('.cc-qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      input.value = btn.getAttribute('data-action') === 'minus' ? Math.max(1, val - 1) : val + 1;
    });

    document.querySelectorAll('#MobileNav .mobile-nav__item > .js-toggle-submenu').forEach(function (btn) {
      var label = btn.querySelector('.mobile-nav__label');
      var txt = label ? label.textContent.trim() : btn.textContent.trim();
      var handle = txt.toLowerCase().replace(/\s+/g, '-');
      var popup = document.querySelector('[data-cc-popup="' + handle + '"]');
      if (!popup || popup.getAttribute('data-cc-mobile-mode') !== 'replace') return;
      btn.style.display = 'none';
      var a = document.createElement('a');
      a.className = 'mobile-nav__link cc-mm-trigger';
      a.href = '#';
      a.setAttribute('data-cc-popup', handle);
      a.innerHTML = '<span class="mobile-nav__label">' + txt + '</span><div class="mobile-nav__icon"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 7 11"><path d="M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z" fill="#fff"/></svg></div>';
      btn.parentNode.insertBefore(a, btn.nextSibling);
    });

    document.querySelectorAll('#MobileNav .mobile-nav__dropdown a.mobile-nav__sublist-link, #MobileNav .mobile-nav__dropdown button.mobile-nav__sublist-link').forEach(function (link) {
      var label = link.querySelector('.mobile-nav__label');
      var txt = label ? label.textContent.trim() : link.textContent.trim();
      if (txt.toLowerCase() !== 'by pecan category') return;
      link.style.display = 'none';
      var a = document.createElement('a');
      a.className = 'mobile-nav__sublist-link cc-mm-trigger';
      a.href = '#';
      a.setAttribute('data-cc-popup', 'pecans');
      a.innerHTML = '<span class="mobile-nav__label">By Pecan Category</span><div class="mobile-nav__icon"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 7 11"><path d="M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z" fill="#fff"/></svg></div>';
      link.parentNode.insertBefore(a, link.nextSibling);
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.cc-mm-trigger');
      if (!trigger) return;
      e.preventDefault();
      var popup = document.querySelector('[data-cc-popup="' + trigger.getAttribute('data-cc-popup') + '"].cc-cn-section');
      if (popup) { popup.style.display = 'block'; popup.setAttribute('aria-hidden', 'false'); }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.cc-close') && !e.target.closest('.cc-overlay')) return;
      document.querySelectorAll('.cc-cn-section, .cc-Making-subcategories-section').forEach(function (el) {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#MobileNav .js-toggle-submenu');
      if (!btn) return;
      e.stopImmediatePropagation();
      var dropdown = btn.nextElementSibling;
      while (dropdown && !dropdown.classList.contains('mobile-nav__dropdown')) dropdown = dropdown.nextElementSibling;
      var isOpen = btn.classList.contains('cc-btn-open');
      document.querySelectorAll('#MobileNav .js-toggle-submenu.cc-btn-open').forEach(function (ob) {
        ob.classList.remove('cc-btn-open');
        var od = ob.nextElementSibling;
        while (od && !od.classList.contains('mobile-nav__dropdown')) od = od.nextElementSibling;
        if (od) od.classList.remove('cc-open');
      });
      if (!isOpen && dropdown) {
        btn.classList.add('cc-btn-open');
        dropdown.classList.add('cc-open');
      }
      setTimeout(function () {
        var wrapper = document.querySelector('.mobile-nav-wrapper.js-menu--is-open');
        var pageContainer = document.getElementById('PageContainer');
        if (wrapper && pageContainer) pageContainer.style.transform = 'translateY(' + wrapper.scrollHeight + 'px)';
      }, 0);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }

})();
